module.exports = __webpack_public_path__ + "assets/985d2a32f6b31696faa86980490cface.mp3";